import { appGetState } from 'legacy/lut/store'

import { IFilter, IPaging, IPagingFromTo } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchGlobalPartners = async (
  filter: IDataProviderFilter,
  paging: IPaging | IPagingFromTo
) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPGlobalPartnersSearch/call`)
  const filters = filter.filters as IFilter[]

  const rtm = filters.find((f) => f.field === 'RTM')?.value
  const searchValue = filters.find((f) => f.field === 'SearchParam')?.value
  const currentFYear = filters.find((f) => f.field === 'FYear')?.value
  const isHQPartnerId = filters.find((f) => f.field === 'isHQPartnerId')?.value
  const isItsValue = filters.find((f) => f.field === 'IsITS')?.value
  const isIts = isItsValue ?? undefined // It's Hiding Empty Optional parameter in Payload

  if (currentFYear && rtm) {
    const pageSize = (paging as IPaging).pageSize
    const page = (paging as IPaging).page

    const payload = {
      'p.RTM': rtm,
      'p.SearchParam': searchValue,
      'p.FYear': currentFYear,
      'p.isHQPartnerId': isHQPartnerId,
      'p.IsITS': isIts,
      take: pageSize,
      skip: pageSize * page,
    }
    const {
      app: { ownerId },
    } = appGetState()
    const [accessToken] = getTokens(ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    if (response && response.Data) {
      return { Data: response.Data }
    }
  }

  return { Data: [] }
}
